type UploadVideoOptions = {
  file: File;
  uploadUrl: string;
  onProgress?: (progress: number) => void;
};

export const uploadVideoWithPresignedUrl = ({
  file,
  uploadUrl,
  onProgress,
}: UploadVideoOptions): Promise<void> => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        const progress = Math.round((event.loaded / event.total) * 100);
        onProgress(progress);
      }
    };

    xhr.onload = () => {
      if ([200, 201, 204].includes(xhr.status)) {
        resolve();
      } else {
        reject(new Error(`Upload failed with status ${xhr.status}`));
      }
    };

    xhr.onerror = () => {
      reject(new Error("Upload failed due to a network error"));
    };

    xhr.open("PUT", uploadUrl);
    xhr.setRequestHeader("Content-Type", file.type);
    xhr.send(file);
  });
};
